import * as React from 'react';
import { Header1, Header2, Header3, Header6, Paragraph2 } from '@cian/ui-kit';
import { ConditionalWrapper } from '@cian/conditional-component';
import cn from 'clsx';
import { head, isNil, tail } from 'ramda';

import * as styles from './styles.css';

export enum EPromoPriceSize {
  XS = 'xs',
  M = 'm',
}

export interface IPromoPriceProps {
  price: string;
  oldPrice: string;
  promoPriceText?: string;
  termsOfPromotion?: string | null;
  size?: EPromoPriceSize;
}

export const PromoPrice: React.FC<IPromoPriceProps> = props => {
  const { oldPrice, promoPriceText, price, size = EPromoPriceSize.M, termsOfPromotion } = props;
  const isSizeM = size === EPromoPriceSize.M;

  /** Первое слово должно содержать ссылку на акцию **/
  const [firstWord, promoText] = React.useMemo(() => {
    if (isNil(promoPriceText)) {
      return [];
    }

    const words = promoPriceText.split(' ');

    return [head(words), tail(words).join(' ')];
  }, [promoPriceText]);

  return (
    <div className={cn(styles['container'], { [styles['size-medium']]: isSizeM })} data-testid="promo-price">
      <div className={styles['price']}>
        <ConditionalWrapper
          if={size === EPromoPriceSize.M}
          ThenComponent={Header1}
          ElseComponent={Header3}
          color="white_100"
        >
          {price}
        </ConditionalWrapper>
        <div className={styles['price-old']}>
          <ConditionalWrapper
            if={size === EPromoPriceSize.M}
            ThenComponent={Header2}
            ElseComponent={Header6}
            color="white_100"
          >
            {oldPrice}
          </ConditionalWrapper>
        </div>
      </div>
      <div className={styles['promo-text']}>
        {termsOfPromotion ? (
          <Paragraph2 color="white_100">
            <a className={styles['promo-link']} href={termsOfPromotion} target="_blank" rel="noreferrer">
              {firstWord}
            </a>{' '}
            <span>{promoText}</span>
          </Paragraph2>
        ) : (
          <Paragraph2 color="white_100">{promoPriceText}</Paragraph2>
        )}
      </div>
    </div>
  );
};

PromoPrice.displayName = 'PromoPrice';
